import { EAppVariant } from "dto/EAppVariant";
import { EAppExtension } from "dto/EAppExtension";

/**
 * Cennik i etykiety pakietów/modułów — odwzorowanie BE (AppPrivileges.cs).
 * Wykorzystywane do podglądu opłaty miesięcznej w panelu edycji subskrypcji
 * (proporcja liczona jest wyłącznie po stronie BE przy rozliczeniu).
 */

/** Miesięczna cena pakietu (zł). */
export const PLAN_PRICE: Record<EAppVariant, number> = {
  [EAppVariant.Free]: 0,
  [EAppVariant.Standard]: 29,
  [EAppVariant.Premium]: 59,
};

export const PLAN_LABEL: Record<EAppVariant, string> = {
  [EAppVariant.Free]: "Bezpłatny",
  [EAppVariant.Standard]: "Standard",
  [EAppVariant.Premium]: "Premium",
};

/** Pojemność dysku przypisana do pakietu (GB). */
export const PLAN_DISK_GB: Record<EAppVariant, number> = {
  [EAppVariant.Free]: 1,
  [EAppVariant.Standard]: 20,
  [EAppVariant.Premium]: 50,
};

export const EXTENSION_LABEL: Record<EAppExtension, string> = {
  [EAppExtension.Tasks]: "Planowanie czynności",
  [EAppExtension.Workspace]: "Praca grupowa",
};

/** Kolejność prezentacji modułów w panelu. */
export const EXTENSION_ORDER: EAppExtension[] = [
  EAppExtension.Tasks,
  EAppExtension.Workspace,
];

export const PLAN_ORDER: EAppVariant[] = [
  EAppVariant.Free,
  EAppVariant.Standard,
  EAppVariant.Premium,
];

/**
 * Cena dokupienia modułu zależy od pakietu bazowego: Premium ma moduły w cenie (0 zł),
 * Standard 19 zł, Bezpłatny 29 zł.
 */
export function getExtensionPrice(
  ext: EAppExtension,
  baseVariant: EAppVariant
): number {
  switch (baseVariant) {
    case EAppVariant.Premium:
      return 0;
    case EAppVariant.Standard:
      return 19;
    default:
      return 29;
  }
}

/**
 * Pełna miesięczna opłata dla wybranej konfiguracji (bez proporcji).
 * Dla Premium moduły są w cenie pakietu.
 */
export function getMonthlyCost(
  variant: EAppVariant,
  extensions: EAppExtension[]
): number {
  if (variant === EAppVariant.Premium) {
    return PLAN_PRICE[EAppVariant.Premium];
  }

  const extensionsCost = (extensions ?? []).reduce(
    (sum, ext) => sum + getExtensionPrice(ext, variant),
    0
  );

  return PLAN_PRICE[variant] + extensionsCost;
}

/** Formatowanie kwoty w złotych, np. 54,5 → "54,50 zł". */
export function formatPrice(value: number): string {
  return `${value.toLocaleString("pl-PL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} zł`;
}
